module.exports = __webpack_public_path__ + "static/media/option-2.38aa6efe.ogg";